import { render, staticRenderFns } from "./StatusLogsList.vue?vue&type=template&id=012a77d8&"
import script from "./StatusLogsList.vue?vue&type=script&lang=js&"
export * from "./StatusLogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports